import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { DashboardWrapperComponent } from '../../../../modules/dashboard-wrapper/dashboard-wrapper.component';
import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { AddNewBankAccountComponent } from '../../components/add-new-bank-account/add-new-bank-account.component';

@Component({
  selector: 'app-dashboard-new-bank-account',
  templateUrl: './dashboard-new-bank-account.component.html',
  styleUrls: ['./dashboard-new-bank-account.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LocalisePipe,
    AddNewBankAccountComponent,
    DashboardWrapperComponent,
  ],
})
export class DashboardNewBankAccountComponent {}
